module.exports = __webpack_public_path__ + "static/media/feature_respin.5cb2cbc9.jpg";